//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dictList, putdevice, bindingImei, getDeviceModel as _getDeviceModel } from '@/api/deviceOverview/file';
export default {
  name: 'fileinfomodel',
  props: {
    fileVisible: {
      type: Boolean,
      default: false
    },
    tit: {
      type: String
    }
  },
  data: function data() {
    return {
      rules: {
        devNumber: [{
          required: true,
          message: this.$t('fileInfo.pleInputAirCode'),
          trigger: 'blur'
        }],
        towerNumber: [{
          required: true,
          message: this.$t('fileInfo.pleInputAirlh'),
          trigger: 'blur'
        }],
        stairsNumber: [{
          required: true,
          message: this.$t('fileInfo.pleInputAirth'),
          trigger: 'blur'
        }],
        devModel: [{
          required: true,
          message: this.$t('fileInfo.pleInputAirxh'),
          trigger: 'blur'
        }],
        elevatorBrand: [{
          required: true,
          message: this.$t('fileInfo.pleInputAirpp'),
          trigger: 'blur'
        }]
      },
      form: {
        elevatorBrand: null,
        devModel: null
      },
      pointChoseType: 'chose',
      formLabelWidth: '190px',
      formLabelWidth1: '190px',
      keyWordObj: null,
      // 关键词检索变量
      map: null,
      disabled: false,
      mapsearch: '',
      disabledLocation: '',
      typeList1: [],
      typeList2: [{
        label: '4G',
        val: '4G'
      }, {
        label: 'WIFI',
        val: 'WIFI'
      }],
      typeList: [],
      wayinfo1: '',
      testarr: [],
      timer: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.$nextTick(function () {// this.$refs.dev.focus()
    });
    this.getdictList();
  },
  methods: {
    getblur: function getblur() {
      this.$nextTick(function () {
        var _this = this;

        if (this.timer) {
          clearTimeout(this.timer);
        }

        this.timer = setTimeout(function () {
          _this.$refs.dev.focus();
        }, 100);
      });
    },
    getDeviceModel: function getDeviceModel(val) {
      var _this2 = this;

      _getDeviceModel({
        devNumber: val
      }).then(function (res) {
        if (res.data.code == 200) {
          var a = _this2.typeList.filter(function (v) {
            return v.dictValue === res.data.data.dictValue;
          });

          if (a.length > 0) {
            _this2.$set(_this2.form, 'devModel', res.data.data.dictKey);
          }
        }
      });
    },
    inputFunc: function inputFunc(val) {
      if (val.length > 11) {
        this.getDeviceModel(val);
      }
    },
    blurinput: function blurinput() {
      if (this.form.imei.length > 14) {
        this.$set(this.form, 'gatewayType', '4G');
      } else if (this.form.imei.length < 13) {
        this.$set(this.form, 'gatewayType', 'WIFI');
      }
    },
    selectBlur1: function selectBlur1(e) {
      this.form.devModel = e.target.value;
      this.form.devModelName = e.target.value;
      this.$forceUpdate();
    },
    selchange1: function selchange1(e) {
      var a = this.typeList.filter(function (v) {
        return v.dictKey === e;
      });
      this.form.devModelName = a[0].dictValue;
      this.form.devModel = e;
    },
    selectBlur: function selectBlur(e) {
      this.form.elevatorBrand = e.target.value;
      this.form.elevatorBrandName = e.target.value;
      this.$forceUpdate();
    },
    selchange: function selchange(e) {
      var a = this.typeList1.filter(function (v) {
        return v.dictKey === e;
      });
      this.form.elevatorBrandName = a[0].dictValue;
      this.form.elevatorBrand = e;
    },
    getdictList: function getdictList() {
      var _this3 = this;

      dictList({
        code: "device_model"
      }).then(function (res) {
        if (res.data.code === 200) {
          _this3.typeList = res.data.data[0].children;
        }
      }); // 电梯

      dictList({
        code: "elevator_brand"
      }).then(function (res) {
        if (res.data.code === 200) {
          _this3.typeList1 = res.data.data[0].children;
        }
      });
    },
    getinfo: function getinfo(info, way) {
      var _this4 = this;

      this.form = JSON.parse(JSON.stringify(info));
      setTimeout(function () {
        console.log(_this4.$refs.dev); // this.$refs.dev.focus()
      }, 100);
    },
    getinfo1: function getinfo1(info) {
      this.wayinfo1 = JSON.parse(JSON.stringify(info));
    },
    closedialog: function closedialog() {
      this.$emit('closefileinfo');
      this.init();
    },
    mapKeyWord: function mapKeyWord() {},
    init: function init() {
      this.form = {};
    },
    // 分页导航
    handleCurrentChange: function handleCurrentChange(val) {
      this.param.current = val;
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      // debugger
      if (this.tit != this.$t('fileInfo.boundBoard')) {
        // if(this.form.projectId){
        //     delete this.form.projectId
        // }
        putdevice(this.form).then(function (res) {
          if (res.data.code === 200) {
            _this5.$message.success('操作成功');

            _this5.getdictList();

            _this5.$emit('closefileinfo', '0');

            _this5.init();
          }
        });
      } else {
        this.form.projectId = this.wayinfo1.id;
        bindingImei(this.form).then(function (res) {
          if (res.data.code === 200) {
            _this5.$emit('closefileinfo', '0');

            _this5.init();
          }
        });
      }
    },
    beforeClose: function beforeClose(done) {
      this.init();
      this.$emit('closefileinfo');
    }
  }
};